define('views/modules/setting/business/list/invoice-history-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'toastr',
    // services
    'services/i18n',
    'services/api',
    'services/user',
    'services/session',
    // views
    'views/parts/form/button',
    // templates
    'text!templates/modules/setting/business/list/invoice-history-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, Toastr,
    // services
    i18n,
    API,
    User,
    Session,
    // views
    VButton,
    // templates
    TInvoiceHistoryListItem
) {

    var VInvoiceHistoryListItem = Backbone.View.extend({
        template: TInvoiceHistoryListItem,
        className: "invoice-list-item",

        regions: {
            downloadInvoice: '.button-download-invoice',
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.view = {
                downloadInvoice: new VButton({
                    label: this.model.getTransactionId(),
                    callback: this.onDownloadInvoice,
                    context: this,
                    icon: false,
                    block: true,
                    tcClass: false,
                    class: "btn-link"
                }),
            };

            this.listenTo(this.model, {
                'remove': this.remove,
            });
        },

        render: function() {
            var view = this.view,
                model = this.model,
                zone = this.zone;

            this.$el.empty().append(
                Mustache.render(
                    this.template,
                    Mustache.getContext(
                        {
                            id: model.getTransactionId(),
                            date: model.getFormatedDate(),
                            total: model.getFormatedTotal()
                        }
                    )
                )
            );

            this.generateZones()
                .assign(view.downloadInvoice, this.zone.$downloadInvoice);

            return this;
        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onDownloadInvoice: function() {
            var xhr = new XMLHttpRequest();
            var url = API.url("payments/archive") + "/" + this.model.getTransactionId() + "/download.pdf";
            var self = this;

            xhr.open("GET", url, true);
            xhr.responseType = "blob";
            xhr.setRequestHeader('Authorization', 'Bearer ' + Session.getToken());
            xhr.onreadystatechange = function(event) {
                if (this.readyState === 4) {
                    if (this.status === 200) {
                        var blob = xhr.response;
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "invoice_" + self.model.getFormatedShortDate() + ".pdf";
                        link.click();
                    } else {
                        Toastr.error(
                            i18n.t('conversation:download_failed_message'),
                            i18n.t('conversation:download_failed_title'),
                            {
                                positionClass: "toast-top-center",
                                newestOnTop: false,
                                showMethod: "slideDown",
                                tapToDismiss: true,
                                timeOut: 5000,
                                closeButton: true
                            }
                        );
                    }
                }
            };

            xhr.send();
        },
    });

    return VInvoiceHistoryListItem;

});

